import React from 'react';
import { ButtonGroup, Button } from '@mui/material';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import LooksOneOutlinedIcon from '@mui/icons-material/LooksOneOutlined';
import PieChartOutlineOutlinedIcon from '@mui/icons-material/PieChartOutlineOutlined';

const ICON_MAP = {
  line: ShowChartOutlinedIcon,
  bar: BarChartOutlinedIcon,
  table: TableChartOutlinedIcon,
  number: LooksOneOutlinedIcon,
  pie: PieChartOutlineOutlinedIcon,
};

export default function ChartTypeToggle({ value, onChange, options = [] }) {
  // If report only supports 1 visualization (e.g. pure tabular reports), don't show toggle at all
  if (!options || options.length <= 1) {
    return null;
  }

  return (
    <ButtonGroup
      size="small"
      variant="outlined"
      sx={{
        mb: 2,
        borderRadius: 2,
        overflow: 'hidden',
        border: '1px solid #d1d5db',
        bgcolor: '#ffffff',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        '& .MuiButtonGroup-grouped': {
          textTransform: 'none',
          fontSize: '0.85rem',
          fontWeight: 600,
          px: 2,
          py: 0.75,
          border: 'none',
          borderRight: '1px solid #e5e7eb',
          '&:last-of-type': {
            borderRight: 'none',
          },
        },
      }}
    >
      {options.map((opt) => {
        const isSelected = value === opt.id;
        const IconComponent = ICON_MAP[opt.icon || opt.id] || ICON_MAP[opt.id];
        return (
          <Button
            key={opt.id}
            onClick={() => onChange(opt.id)}
            startIcon={IconComponent ? <IconComponent sx={{ fontSize: '1.15rem !important' }} /> : null}
            sx={{
              bgcolor: isSelected ? '#00a884 !important' : 'transparent',
              color: isSelected ? '#ffffff !important' : '#475569 !important',
              '&:hover': {
                bgcolor: isSelected ? '#008f70 !important' : '#f8fafc !important',
              },
              transition: 'background-color 0.15s ease-in-out, color 0.15s ease-in-out',
            }}
          >
            {opt.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}
